import UpdateBusiness from './Update';
export default UpdateBusiness;